module.exports = __webpack_public_path__ + "img/personalized-offer-image.7663dc7f.svg";